import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from 'src/app/services/loading.service';

import { SettingsProvider } from 'src/app/services/settings';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class MainService {

  // private _url: string = 'https://lacascadaorganization.dev.solunes.com/api';
  private _auth_token: string | null = localStorage.getItem('tempToken');
  // private _auth_token: string = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5OWYxZmU2MS1iY2I5LTRlMTEtOWMyMy04YzZlNDRjODI1MGMiLCJqdGkiOiJiYTk3YzU0Zjg4MDdkOGFhNDdjZDNkMzU2ZTVmMTJhMzg2NzRkY2FjMTQ4MzcwMmZiNDc5M2FmYzA3ZGNjM2VlN2QxZTU2NTZhZGVlMThlNyIsImlhdCI6MTY5NjQ1NTA4Mi43MjMxMDEsIm5iZiI6MTY5NjQ1NTA4Mi43MjMxMDgsImV4cCI6MTcxMjI2NjI4Mi43MTg0MTQsInN1YiI6IjciLCJzY29wZXMiOltdfQ.zNIJ1XFzwzmUPTH0toFR9p5LnlsjVeQ3_r_mqQ7s5oTgIfLzeEk4scbR8EMFezh4FS3uCWxQV4OPuYUT0kPsHsL6wornH_pwahtjM9hHDtdXiglp3UyvoahlaVKMiZtD7Bey7mPrbxfJP1ya7ecJ1ZTnclCK5U5xy1Z9jv9hr8gmIwpGDmSuXRxNiSclCusqirDM-9zooleocMkGoXhmGRVYmtosEtfPHDLBuKOgW2Y--ZGrZ8ylMYK80EVy0wVzFe9hb88egQgkQt0t27dVKYicoSKiKoHI1s-LrFqKbk26lDEtH2vXQUvgrDSUb2SwA4te441rtzxqdvCpnwq4rLqMNvfzmG3dboX3-q6s7HJFofOTPDgG2IspsI4GFksatJzZ_NP_Cf1-la3MFOJuxQYaa_HFRDo3chaq_7j2I28tbNTccVRu14u6sxRFBzGLSHsK0lpAifpPueNmyTKVZsuEZw3xkpv9_SUFvrcmVmQuIahw_HVUoPuzwIHBNYuaWsv2nDw6WrKN5AqFkINUMnDf8uZADlCg-xIlg7W5exqyn3Hiq_smWsSfaXYLL31SQusb5ELtk06FOjvYgmQsxhHHRVrRbaAFjso9BxZcvenG52IfsFzyE74jeO6xB2ZkE9_J8zVfuq4eoyOiVa67gbrnjbn3T6S_xhf9W5ZJoRQ";

  public changeSubPackage$ = new BehaviorSubject<number>(1);
  public addEgressQuantity$ = new BehaviorSubject<any>({});
  public editAttribute$ = new BehaviorSubject<any>({});
  public editSupOp$ = new BehaviorSubject<any>({});
  public editSupply$ = new BehaviorSubject<any>({});
  public editExternal$ = new BehaviorSubject<any>({});
  public editTask$ = new BehaviorSubject<any>({});

  constructor(
    private http: HttpClient,
    private toast: ToastrService,
    private load: LoadingService,
    private router: Router,
    private authService: AuthService
  ) { }

  private ensureAuthenticatedOrAbort() {
    const currentUrl = this.router.url?.toLowerCase() || '';
    if (currentUrl.startsWith('/auth') || currentUrl.startsWith('/set-password') || currentUrl.startsWith('/documentation') || currentUrl.includes('/error/')) {
      return true;
    }

    if (!this.authService.ensureAuthenticated()) {
      this.load.dismiss();
      return false;
    }
    return true;
  }

  get_request(endPoint: string, fields?: object){
    if (!this.ensureAuthenticatedOrAbort()) {
      return of([]);
    }

    let params = new HttpParams()
      // .set('Authorization', `Bearer ${this._auth_token}`)
      // .set('accept', `application/json`);

    if(fields != undefined){
      for (const key in fields as Record<string, unknown>) {
        if (Object.prototype.hasOwnProperty.call(fields, key)) {
          params = params.set(`${key}`, `${(fields as Record<string, unknown>)[key]}`);
        }
      }
    }
    let headers = new HttpHeaders({
      Authorization: `Bearer ${this._auth_token || this.authService.getToken() || ''}`
    });
    this.load.loadingShow();
    return this.http.get( SettingsProvider.getUrl(endPoint), { headers, params })
      .pipe(
        catchError((error: any) => {
          // this.load.dismiss();

          if(error.errors != null){
            error.errors.forEach((element: unknown) => {
              this.toast.error( String(element) , '', {timeOut: 5000, progressBar: true, closeButton: true} );
            });
          }else{
            this.manageErrors(error);
            this.toast.error( error.message , '', {timeOut: 5000, progressBar: true, closeButton: true} );
          }

          return of([])
        }),
        tap( () => { this.load.dismiss(); } )
      )
  }

  get_requestBlob(endPoint: string, fields?: object){
    if (!this.ensureAuthenticatedOrAbort()) {
      return of([]);
    }

    let params = new HttpParams()
      // .set('Authorization', `Bearer ${this._auth_token}`)
      // .set('accept', `application/json`);

    if(fields != undefined){
      for (const key in fields as Record<string, unknown>) {
        if (Object.prototype.hasOwnProperty.call(fields, key)) {
          params = params.set(`${key}`, `${(fields as Record<string, unknown>)[key]}`);
        }
      }
    }
    let headers = new HttpHeaders({
      Authorization: `Bearer ${this._auth_token || this.authService.getToken() || ''}`
    });
    this.load.loadingShow();
    return this.http.get( SettingsProvider.getUrl(endPoint), { headers, params, responseType: 'blob' })
      .pipe(
        catchError((error: any) => {
          // this.load.dismiss();

          if(error.errors != null){
            error.errors.forEach((element: unknown) => {
              this.toast.error( String(element) , '', {timeOut: 5000, progressBar: true, closeButton: true} );
            });
          }else{
            this.manageErrors(error);
            this.toast.error( error.message , '', {timeOut: 5000, progressBar: true, closeButton: true} );
          }

          return of([])
        }),
        tap( () => { this.load.dismiss(); } )
      )
  }

  post_request(endPoint: string, body: any){
    if (!this.ensureAuthenticatedOrAbort()) {
      return of([]);
    }

    let headers = new HttpHeaders({
      Authorization: `Bearer ${this.authService.getToken()}`
    });
    this.load.loadingShow();
    return this.http.post( SettingsProvider.getUrl(endPoint), body, { headers })
      .pipe(
        catchError( error => {
          // this.load.dismiss();
          // console.log(error, 'error');

          // if(error.error.errors != null){
          //   for (const key in error.error.errors) {
          //     if (Object.prototype.hasOwnProperty.call(error.error.errors, key)) {
          //       error.error.errors[key].forEach(element => {
          //         this.toast.error( element , '', {timeOut: 5000, progressBar: true, closeButton: true} );
          //       });
          //     }
          //   }
          // }else{
          //   this.toast.error( error.error.message , '', {timeOut: 5000, progressBar: true, closeButton: true} );
          // }
          // error.errors.forEach(element => {
          //   this.toast.error( element , '', {timeOut: 5000} );
          // });
          return of([])
        }),
        tap( () => { this.load.dismiss(); } )
      )
  }

  put_request(endPoint: string, body: any){
    if (!this.ensureAuthenticatedOrAbort()) {
      return of([]);
    }

    let headers = new HttpHeaders({
      Authorization: `Bearer ${this.authService.getToken()}`
    });
    this.load.loadingShow();
    return this.http.put( SettingsProvider.getUrl(endPoint), body, { headers })
      .pipe(
        catchError( error => {
          // this.load.dismiss();
          // console.log(error, 'error');

          // if(error.error.errors != null){
          //   for (const key in error.error.errors) {
          //     if (Object.prototype.hasOwnProperty.call(error.error.errors, key)) {
          //       error.error.errors[key].forEach(element => {
          //         this.toast.error( element , '', {timeOut: 5000, progressBar: true, closeButton: true} );
          //       });
          //     }
          //   }
          // }else{
          //   this.toast.error( error.error.message , '', {timeOut: 5000, progressBar: true, closeButton: true} );
          // }
          // error.errors.forEach(element => {
          //   this.toast.error( element , '', {timeOut: 5000} );
          // });
          return of([])
        }),
        tap( () => { this.load.dismiss(); } )
      )
  }

  post_request_no_loader(endPoint: string, body: any){
    if (!this.ensureAuthenticatedOrAbort()) {
      return of([]);
    }

    let headers = new HttpHeaders({
      Authorization: `Bearer ${this.authService.getToken()}`
    });
    // this.load.loadingShow();
    return this.http.post( SettingsProvider.getUrl(endPoint), body, { headers })
      .pipe(
        catchError( error => {
          // this.load.dismiss();
          // console.log(error, 'error');

          // if(error.error.errors != null){
          //   for (const key in error.error.errors) {
          //     if (Object.prototype.hasOwnProperty.call(error.error.errors, key)) {
          //       error.error.errors[key].forEach(element => {
          //         this.toast.error( element , '', {timeOut: 5000, progressBar: true, closeButton: true} );
          //       });
          //     }
          //   }
          // }else{
          //   this.toast.error( error.error.message , '', {timeOut: 5000, progressBar: true, closeButton: true} );
          // }
          // error.errors.forEach(element => {
          //   this.toast.error( element , '', {timeOut: 5000} );
          // });
          return of([])
        }),
        tap( () => {  } )
      )
  }

  delete_request(endPoint: string, fields?: object){
    if (!this.ensureAuthenticatedOrAbort()) {
      return of([]);
    }

    let params = new HttpParams()
      .set('Authorization', `Bearer ${this.authService.getToken()}`)
      // .set('accept', `application/json`);

    if(fields != undefined){
      for (const key in fields as Record<string, unknown>) {
        if (Object.prototype.hasOwnProperty.call(fields, key)) {
          params = params.set(`${key}`, `${(fields as Record<string, unknown>)[key]}`);
        }
      }
    }
    this.load.loadingShow();
    return this.http.delete( SettingsProvider.getUrl(endPoint), { params })
      .pipe(
        catchError((error: any) => {
          // this.load.dismiss();
          // console.log(error, 'error ');
          this.toast.error( error.error.message , '', {timeOut: 5000, progressBar: true, closeButton: true} );

          // error.errors.forEach(element => {
          //   this.toast.error( element , '', {timeOut: 5000} );
          // });

          return of([])
        }),
        tap( () => { this.load.dismiss(); } )
      )
  }

  manageErrors(error: any){

    if(error.statusText === "Unknown Error"){
      localStorage.removeItem('auth');
      this.router.navigate(['/auth/login']);
    }
  }
}
